module.exports = __webpack_public_path__ + "img/477.a1e0880b.jpg";